import { style } from 'typestyle';
import { colors } from 'styles/styles';

export const input = style({
  display: "flex",
  border: "2.5px solid " + colors.hooplaPurple,
  borderRadius: "9px",
  width:"100%",
  background: colors.hooplaWhite,
  alignItems: "center",
  boxSizing: "border-box",
  overflow: "hidden",
  $nest: {
    '&:disabled': {
      color: colors.grey_20,
    },
    "&>[type=email]": {
      border: 0,
      flex: "1 0 auto",
      fontSize: "22px",
      padding: "18px 13px",
      background: "transparent",
      outline: "none"
    },
    "&>[type=text]": {
      border: 0,
      flex: "1 0 auto",
      fontSize: "22px",
      padding: "18px 13px",
      background: "transparent",
      outline: "none"
    },
  }
})

export const labeledInput = style({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',

  $nest: {
    'label': {
      color: colors.hooplaTextColor,
      marginBottom: '0.5rem',
      opacity: "0.7"
    }
  }
})
